import { Reveal } from "../Reveal";
import { ABOUT_PARAGRAPHS, ABOUT_CLOSING, IMAGES } from "../../config/site";

export const About = () => {
  return (
    <section id="sobre" data-testid="about-section" className="relative py-24 md:py-32 bg-paper">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <Reveal>
              <span className="font-body text-xs tracking-[0.3em] uppercase text-gold">Sobre a TEMPLO BH</span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display text-ink uppercase tracking-tight leading-[0.95] text-4xl md:text-5xl lg:text-6xl mt-5">
                Mais que uma luta.<br /><span className="text-gold">Uma cultura.</span>
              </h2>
            </Reveal>
            <div className="mt-8 flex flex-col gap-5 max-w-2xl">
              {ABOUT_PARAGRAPHS.map((p, i) => (
                <Reveal key={i} delay={0.06 + i * 0.02}>
                  <p className="font-body text-slate/85 text-base md:text-[17px] leading-relaxed">{p}</p>
                </Reveal>
              ))}
              <Reveal delay={0.1}>
                <p className="font-display text-ink uppercase tracking-[0.06em] text-lg md:text-xl mt-2">{ABOUT_CLOSING}</p>
              </Reveal>
            </div>
          </div>
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <Reveal delay={0.1}>
              <div className="rounded-2xl overflow-hidden border border-line">
                <img src={IMAGES.about} alt="Sócios da Templo BH: Rafael, Lívia e Victor" className="w-full h-auto block" />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
